/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  parseDependencies: parseDependencies,
  createParserClass: createParserClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesParserClass.generated.js
// module id = 513
// module chunks = 0